<template>
  <aside>
    <DxList
      :data-source="notifications"
      displayExpr="message"
      :no-data-text="'No data'"
      height="300px"
      class="notifications-list"
    >
      <template #itemTemplate="{ data }">
        <div class="notification-item row">
          <div class="column justify-center">
            <div v-if="!data.isSeen" class="blue-dot"></div>
          </div>

          <div class="column main-col">
            <span class="notification-message">
              {{ moment(data.createdDate).format("DD-MM-YYYY") }}
            </span>
            <span
              class="notification-message"
              @click="markNotificationAsSeen(data)"
            >
              {{ data.message }} </span
            ><span class="notificaiton-message" style="padding-left: 8px">
              <router-link
                class="edit-link"
                :to="{
                  name: 'EditScheme',
                  params: { id: data.schemeId }
                }"
                v-bind:target="'_blank'"
                style="text-decoration: underline; cursor: default"
              >
                {{ "Click this link to view the scheme." }}
              </router-link>

              <i
                v-if="data.isSeen"
                class="las la-2x la-trash edit-remark-icon"
                @click.stop="deleteNotificationById(data.id)"
              ></i>
            </span>
          </div>
        </div>
      </template>
    </DxList>
  </aside>
</template>

<script setup>
import { computed, defineProps } from "vue";
import moment from "moment";
import { DxList } from "devextreme-vue/list";

const props = defineProps({
  data: {
    type: Array,
    required: true,
    default: () => []
  },
  markNotificationAsSeen: {
    type: Function,
    required: true
  },
  deleteNotification: {
    type: Function,
    required: true
  }
});

const notifications = computed(() => props.data);

const markNotificationAsSeen = data => {
  if (!data.isSeen) {
    props.markNotificationAsSeen(data.id);
  }
};

const deleteNotificationById = async id => {
  props.deleteNotification(id);
};
</script>

<style lang="scss" scoped>
.blue-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #25408f;
  align-self: center;
}

.notification-item {
  display: flex;
}

.notification-message {
  padding-left: 8px !important;
  max-width: 90% !important;
  white-space: initial !important;
}

.notifications-list {
  width: 400px !important;
}

.main-col {
  width: 95%;
}
</style>
